import UseQuery from "@/src-refactor/modules/shared/hooks/use-query.hook";
import usePropertyHelpTypeLocations from "./helps/usePropertyHelpTypeLocations";
import {
  C_REALESTATE_TYPES,
  O_REALESTATE_TYPES,
  O_REALESTATE_TYPES_PROJECT
} from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { CPropertyFormKeys } from "../util/schemas/property-schema/propertySchema";
import HCheckArray from "@rf-helper/check-have-value";

const useGetTypePropertyFromUrl = () => {
  const { query } = UseQuery();
  const { isProject } = usePropertyHelpTypeLocations();
  const getTypeProperty = () => {
    if (isProject) {
      return [
        O_REALESTATE_TYPES_PROJECT[query.type] || C_REALESTATE_TYPES.APARTMENT
      ];
    } else {
      return [O_REALESTATE_TYPES[query.type] || C_REALESTATE_TYPES.APARTMENT];
    }
  };

  return {
    getTypeProperty
  };
};

export default useGetTypePropertyFromUrl;

/**
 * Check if the type property is the same as the one in the URL
 * If it is not the same, it will be replaced by the one in the URL
 * @returns void
 * @example
 * @deprecated use usePropertyDraftV2 instead
 **/
export const useCheckTypeProperty = () => {
  const { query } = UseQuery();
  const { getValues, setValue, trigger } = useFormContext();
  const { getTypeProperty } = useGetTypePropertyFromUrl();
  useEffect(() => {
    if (query.type) {
      const type = getValues(CPropertyFormKeys.type_property);
      if (HCheckArray(type)) {
        if (type[0].id != query.type) {
          setValue(CPropertyFormKeys.type_property, getTypeProperty(), {
            shouldValidate: true,
            shouldDirty: true
          });
          trigger();
        }
      }
    }
  }, [query.type]);
};
